/*
 * @Author       : qixiao
 * @Date         : 2023-05-13 10:56:05
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-15 18:57:04
 * @FilePath     : \hzs-Houtai\src\store\index.js
 * @Description  : 
 * 
 */
/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2022-02-19 19:14:34
 * @LastEditors: liushumin
 * @LastEditTime: 2022-09-22 09:19:40
 */
import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import map from "./modules/map";
import Agricultural from "./modules/Agricultural";
import szStatus from './modules/szStatus';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    map,
    szStatus,
    Agricultural
  },
  state,
  mutations,
  actions,
});
